<template>
  <div class="content">
    <div v-if="!web3" class="log-in" @click="connectWallet">获取</div>
    <div v-else>
      <div class="user-msg">
        <div class="msg-item">
          <div class="msg-key">当前地址</div>
          <div class="msg-value" @click="showAddressFun"><span>{{walletAddressBefore}}...{{walletAddressAfter}}</span>
            <svg style="margin-left:8px" t="1664714005092" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9543" width="18" height="18"><path d="M399.872 160.256v256h-256v-256h256m0-64h-256c-35.328 0-64 28.672-64 64v256c0 35.328 28.672 64 64 64h256c35.328 0 64-28.672 64-64v-256c0-35.328-28.672-64-64-64z m480.256 64v256h-256v-256h256m0-64h-256c-35.328 0-64 28.672-64 64v256c0 35.328 28.672 64 64 64h256c35.328 0 64-28.672 64-64v-256c0-35.328-28.672-64-64-64z m-480.256 512v256h-256v-256h256m0-64h-256c-35.328 0-64 28.672-64 64v256c0 35.328 28.672 64 64 64h256c35.328 0 64-28.672 64-64v-256c0-35.328-28.672-64-64-64z m192 351.744c-19.456 0-32.256-12.8-32.256-32.256v-256c0-19.456 12.8-32.256 32.256-32.256s32.256 12.8 32.256 32.256v256c0 16.384-15.872 32.256-32.256 32.256z m157.184 0c-19.456 0-32.256-12.8-32.256-32.256v-256c0-19.456 12.8-32.256 32.256-32.256s32.256 12.8 32.256 32.256v256c-0.512 16.384-16.384 32.256-32.256 32.256z m162.816 0c-19.456 0-32.256-12.8-32.256-32.256v-256c0-19.456 12.8-32.256 32.256-32.256s32.256 12.8 32.256 32.256v256c0 16.384-15.872 32.256-32.256 32.256z" p-id="9544" fill="#515151"></path></svg>
          </div>
        </div>
        <div class="msg-item">
          <div class="msg-key">当前ETH余额</div>
          <div class="msg-value">{{balanceInEth}}</div>
        </div>
        <div class="msg-item">
          <div class="msg-key">当前USDT余额</div>
          <div class="msg-value">{{balanceInUSDT}}</div>
        </div>
      </div>
      <div>
        <input type="text" class="send-input" placeholder="输入目标地址" v-model="toAddress">
      </div>
      <div>
        <input type="text" class="send-input" placeholder="输入发送数量" v-model="tokenAmount">
      </div>
      <!-- <div class="tool-btns">
        <div class="tool-btn" @click="toWei(18)">toWei(10^18)</div>
        <div class="tool-btn" @click="toWei(9)">toGwei(10^9)</div>
      </div> -->
      <div class="btns">
        <div class="send-btn usdt" @click="sendUsdt">向地址转 USDT</div>
        <div class="send-btn eth" @click="sendEth">向地址转 ETH</div>
        <div class="send-btn eth" @click="sendNft">向地址mint NFT</div>
        <div class="send-btn eth" @click="main">main</div>
        <div class="send-btn eth" @click="addEthereumChainFun">添加网络</div>
      </div>
    </div>
    <div v-if="showAddress" class="dialog" @click="hiddenAddressFun">
      <div class="dialog-content" @click.stop>
        <div class="qr-code">
          <qrcode-vue :value="walletAddress" size="150" level="H" id="canvasDom" class="qrcode" />
          <img v-if="imgUrl" :src="imgUrl" alt="">
        </div>
        <div class="dialog-address">{{walletAddress}}
          <svg @click="copy" t="1664717295279" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12119" width="18" height="18"><path d="M568.7 319.8l86.8 86.8v476.6h-466V319.8h379.2m29-70H178.9c-32.8 0-59.4 26.5-59.4 59.3v584.7c0 15.7 6.3 30.8 17.4 42 11.1 11.2 26.2 17.4 42 17.4h487.4c15.7 0 30.8-6.3 41.9-17.4 11.1-11.1 17.3-26.2 17.3-42V377.6L597.7 249.8z" fill="#000000" p-id="12120"></path><path d="M776.7 70.8H357.9c-32.8 0-59.4 26.5-59.4 59.3v100h70v-89.3h379.2l86.8 86.8v476.6h-85.8v70h96.6c15.7 0 30.8-6.3 41.9-17.4 11.1-11.1 17.3-26.2 17.3-42V198.6L776.7 70.8z" fill="#000000" p-id="12121"></path></svg>
        </div>
      </div>
    </div>
    <div v-if="loading" class="dialog" style="background: rgba(0, 0, 0, .5)">
      <div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </div>
  </div>
</template>

<script>
import { connectWalletFun, contractFun } from '../assets/js/connectWallet';
import { walletSwitchChain, addEthereumChain } from '../assets/js/walletSwitchChain'
import { ethers } from 'ethers'
import { ref, markRaw, onMounted } from 'vue'
import QrcodeVue from 'qrcode.vue'
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  components: {
    QrcodeVue
  },
  setup() {
    const showAddress = ref(false)
    const loading = ref(false)
    const web3 = ref(null)
    const walletAddressBefore = ref('')
    const walletAddressAfter = ref('')
    const walletAddress = ref('')
    const balanceInEth = ref('')
    const balanceInUSDT = ref('')
    const imgUrl = ref('')
    const toAddress = ref('')
    const tokenAmount = ref('')
    const network = ref(null)
    const contract = ref(null)
    const contractAddress = '0xdAC17F958D2ee523a2206206994597C13D831ec7'
    const abi = '[{"constant":true,"inputs":[],"name":"name","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_upgradedAddress","type":"address"}],"name":"deprecate","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_value","type":"uint256"}],"name":"approve","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"deprecated","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_evilUser","type":"address"}],"name":"addBlackList","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transferFrom","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"upgradedAddress","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"}],"name":"balances","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"maximumFee","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"_totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"unpause","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_maker","type":"address"}],"name":"getBlackListStatus","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"},{"name":"","type":"address"}],"name":"allowed","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"paused","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"who","type":"address"}],"name":"balanceOf","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"pause","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"getOwner","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transfer","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"newBasisPoints","type":"uint256"},{"name":"newMaxFee","type":"uint256"}],"name":"setParams","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"amount","type":"uint256"}],"name":"issue","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"amount","type":"uint256"}],"name":"redeem","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"},{"name":"_spender","type":"address"}],"name":"allowance","outputs":[{"name":"remaining","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"basisPointsRate","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"}],"name":"isBlackListed","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_clearedUser","type":"address"}],"name":"removeBlackList","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"MAX_UINT","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_blackListedUser","type":"address"}],"name":"destroyBlackFunds","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"inputs":[{"name":"_initialSupply","type":"uint256"},{"name":"_name","type":"string"},{"name":"_symbol","type":"string"},{"name":"_decimals","type":"uint256"}],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":false,"name":"amount","type":"uint256"}],"name":"Issue","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"name":"amount","type":"uint256"}],"name":"Redeem","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"name":"newAddress","type":"address"}],"name":"Deprecate","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"name":"feeBasisPoints","type":"uint256"},{"indexed":false,"name":"maxFee","type":"uint256"}],"name":"Params","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"name":"_blackListedUser","type":"address"},{"indexed":false,"name":"_balance","type":"uint256"}],"name":"DestroyedBlackFunds","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"name":"_user","type":"address"}],"name":"AddedBlackList","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"name":"_user","type":"address"}],"name":"RemovedBlackList","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"owner","type":"address"},{"indexed":true,"name":"spender","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"address"},{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[],"name":"Pause","type":"event"},{"anonymous":false,"inputs":[],"name":"Unpause","type":"event"}]'
    let networkValue = {}
    const connectWallet = () => {
      loading.value = true
      connectWalletFun().then(async res => {
        console.log(res)
        try {
          let web3Value = res
          let userValue = web3Value.getSigner()
          let walletAddressValue = await userValue.getAddress()
          let balanceValue = await web3Value.getBalance(walletAddressValue)
          let balanceInEthValue = ethers.utils.formatEther(balanceValue);
          networkValue = await web3Value.getNetwork()
          console.log('provider:', web3Value)
          console.log('walletWithProvider:', userValue)
          console.log('walletAddress:', walletAddressValue)
          console.log('balance:', balanceValue)
          console.log('network:', networkValue)
          if (networkValue.chainId == 1) {
            let contractValue = await contractFun(contractAddress, abi, userValue)
            let decimalsValue = await contractValue.decimals()
            let decimals = ethers.utils.formatUnits(decimalsValue, 0)
            let balanceInUSDTValue = await contractValue.balances(walletAddressValue)
            balanceInUSDTValue = ethers.utils.formatUnits(balanceInUSDTValue, +decimals)
            balanceInUSDT.value = (+balanceInUSDTValue).toFixed(2)
            contract.value = contractValue
          }
          network.value = networkValue
          balanceInEth.value = (+balanceInEthValue).toFixed(2)
          walletAddressBefore.value = walletAddressValue.slice(0, 7)
          walletAddressAfter.value = walletAddressValue.slice(-5)
          walletAddress.value = walletAddressValue
          web3.value = markRaw(web3Value)
          loading.value = false
        } catch (error) {
          console.log(error)
          loading.value = false
        }
      }).catch(err => {
        console.log(err)
        loading.value = false
      })
    }
    const main = () => {
      let chain_id = 5
      let rpcurl = 'http://127.0.0.1:3333/v1'
      const provider = new ethers.providers.JsonRpcProvider(rpcurl)
      console.log(chain_id, provider)
    }

    // {
//   chainId: '0x' + (+chain.chainId).toString(16), // 目标链ID
//   chainName: chain.name,
//   nativeCurrency: chain.nativeCurrency,
//   rpcUrls: chain.rpc, // 节点
// }
    const addEthereumChainFun = () => {
      addEthereumChain({
        chainId: '0x' + (+5).toString(16),
        chainName: 'Jetable Ethereum  Mainnet',
        nativeCurrency: {
          "name": "Ether",
          "symbol": "ETH",
          "decimals": 18
        },
        rpcUrls: ['https://eth-goerli.g.alchemy.com/v2/Ld8v5NALjjmsegSZboRblK-NzizejJOb'],
        blockExplorerUrls: ['https://eth-goerli.g.alchemy.com/v2/Ld8v5NALjjmsegSZboRblK-NzizejJOb'],
      }).then(res => {
        console.log(res)
      }).catch(err => {
        console.log(err)
      })
    }
    const changeNetwork = (id) => {
      loading.value = true
      walletSwitchChain(id).then(res => {
        console.log(res)
        connectWallet()
      }).catch(err => {
        console.log(err)
        loading.value = false
      })
    }
    const downLoadQRcode = () => {
      const canvas = document.getElementById('canvasDom')
      const url = canvas.toDataURL("image/png") // 通过 toDataURL 返回一个包含图片展示的 data URI 
      imgUrl.value = url
      // const aDom = document.createElement("a")
      // let event = new MouseEvent('click')
      // aDom.download = '1'// 设置下载的文件名
      // aDom.href = url
      // document.body.appendChild(aDom)
      // // aDom.click()
      // aDom.dispatchEvent(event)
      // aDom.remove()
    }
    const showAddressFun = () => {
      showAddress.value = true
      setTimeout(() => {
        downLoadQRcode()
      }, 0)
    }
    const hiddenAddressFun = () => {
      showAddress.value = false
      imgUrl.value = ''
    }
    const copy = () => {
      var textareaC = document.createElement('textarea');
      textareaC.setAttribute('readonly', 'readonly'); //设置只读属性防止手机上弹出软键盘
      textareaC.value = walletAddress.value;
      document.body.appendChild(textareaC); //将textarea添加为body子元素
      textareaC.select();
      document.execCommand('copy');
      document.body.removeChild(textareaC);//移除DOM元素
      console.log("复制成功");
      alert('复制成功')
    }
    const sendNft = () => {
      if (networkValue.chainId != 5) {
        changeNetwork(5)
        return
      }
      if (!toAddress.value) {
        alert('请输入目标地址')
        return
      }
      loading.value = true
      let contract = new ethers.Contract('0xcF06AE357cD94c520c1627f4F29c4189eA9C8DA2', '[{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"approved","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":false,"internalType":"bool","name":"approved","type":"bool"}],"name":"ApprovalForAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"approve","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"getApproved","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"operator","type":"address"}],"name":"isApprovedForAll","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_to","type":"address"}],"name":"mint","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"ownerOf","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"operator","type":"address"},{"internalType":"bool","name":"approved","type":"bool"}],"name":"setApprovalForAll","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"tokenId","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"tokenURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"transferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"}]', web3.value.getSigner())
      contract.mint(toAddress.value).then(async (transaction) => {
        let receipt = await transaction.wait()
        alert("发送成功")
        console.log(receipt)
        loading.value = false
      }).catch(err => {
        alert(err.message)
      })
    }
    const sendEth = () => {
      if (networkValue.chainId != 1) {
        changeNetwork(1)
        return
      }
      if (!toAddress.value) {
        alert('请输入目标地址')
        return
      } else if (!tokenAmount.value) {
        alert('请输入发送数量')
        return
      }
      loading.value = true
      let tx = {
        from: walletAddress.value,
        to: toAddress.value,
        value: ethers.utils.parseEther(tokenAmount.value)
      }
      console.log(tx)
      web3.value.getSigner().sendTransaction(tx).then(async (transaction) => {
        console.dir(transaction)
        const receipt = await transaction.wait()
        alert("发送成功")
        console.log(receipt)
        loading.value = false
      }).catch(err => {
        console.log(err)
        if (err.message) {
          alert(err.message)
        }
        loading.value = false
      })
    }
    const toWei = (decimalsValue) => {
      if (!tokenAmount.value) {
        alert('请输入发送数量')
        return
      }
      let tokenAmountValue = ethers.utils.parseUnits(tokenAmount.value.toString(), decimalsValue).toString()
      tokenAmount.value = tokenAmountValue
    }
    const sendUsdt = async () => {
      if (networkValue.chainId != 1) {
        changeNetwork(1)
        return
      }
      if (!toAddress.value) {
        alert('请输入目标地址')
        return
      } else if (!tokenAmount.value) {
        alert('请输入发送数量')
        return
      }
      loading.value = true
      let decimalsValue = await contract.value.decimals()
      let decimals = ethers.utils.formatUnits(decimalsValue, 0)
      let numberOfTokens = ethers.utils.parseUnits(tokenAmount.value, decimals)
      console.log(`numberOfTokens: ${numberOfTokens}`)

      // Send tokens
      contract.value.transfer(toAddress.value, numberOfTokens).then(async (transferResult) => {
        console.dir(transferResult)
        const receipt = await transferResult.wait()
        alert("发送成功")
        console.log(receipt)
        loading.value = false
      }).catch(err => {
        console.log(err)
        if (err.message) {
          alert(err.message)
        }
        loading.value = false
      })
    }
    const fn = () => {
      let ethereum = window.ethereum
      ethereum.on("accountsChanged", (accounts) => {
        console.log("账号切换", accounts[0])
        if (!accounts[0]) {
          web3.value = ''
          walletAddressBefore.value = ''
          walletAddressAfter.value = ''
          walletAddress.value = ''
        } else {
          connectWallet()
        }
      })
      ethereum.on("chainChanged", (chainId) => {
        console.log("用户切换了链", chainId)
        connectWallet()
      })
    }
    onMounted(() => {
      fn()
    })
    return {
      loading,
      web3,
      tokenAmount,
      walletAddressBefore,
      walletAddressAfter,
      walletAddress,
      balanceInEth,
      network,
      contract,
      balanceInUSDT,
      connectWallet,
      changeNetwork,
      imgUrl,
      toAddress,
      showAddress,
      showAddressFun,
      hiddenAddressFun,
      copy,
      sendEth,
      toWei,
      sendUsdt,
      sendNft,
      main,
      addEthereumChainFun
    }
  },
}
</script>

<style scoped>
.content {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 750px;
  margin: auto;
  min-height: 100vh;
  font-size: 0;
  padding: 0 .4rem;
  box-sizing: border-box;
}

.user-msg {
  width: 6.78rem;
  margin-bottom: .6rem;
}

.msg-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: .28rem;
  height: .66rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
  line-height: 1;
}

.msg-key {
  font-size: .28rem;
}

.msg-value {
  display: flex;
  align-items: center;
  font-weight: 500;
}

.log-in {
  width: 2.5rem;
  height: .8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: .32rem;
  background: #1E2022;
  border-radius: 6px;
  color: #FFF;
}
.btns {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

.send-btn {
  width: 2.5rem;
  height: .8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: .32rem;
  border-radius: .1rem;
  color: #FFF;
  margin-bottom: .2rem;
}
.send-input {
  width: 6.78rem;
  padding: 0;
  box-sizing: border-box;
  border: none;
  background: none;
  border: 1px solid #E8EAEF;
  border-radius: 4px;
  height: .68rem;
  margin-bottom: .4rem;
  padding: 0 .18rem;
  outline: none;
  font-size: .28rem;
}
.usdt {
  background: #2636C8;
  margin-right: .48rem
}
.eth {
  background: #1E2022;
}

.dialog {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.dialog-content {
  padding: .4rem .32rem;
  box-sizing: border-box;
  background: #FFF;
  width: 6rem;
  display: flex;
  align-items: center;
  overflow: hidden;
  flex-direction: column;
  border-radius: .2rem;
}

.qr-code img {
  width: 3.2rem;
  height: auto;
}

.dialog-address {
  margin-top: .2rem;
  font-size: .28rem;
  line-height: 1.6;
  width: 5rem;
  word-break: break-all;
  text-align: center;
  font-weight: 500;
}

.dialog-address svg {
  margin-top: -6px;
  vertical-align: middle;
}

.qrcode {
  position: absolute;
  z-index: -99;
  left: -9999px;
  top: -9999px;
}
.tool-btns {
  display: flex;
  align-items: center;
  margin-top: -.2rem;
  margin-bottom: .4rem;
  justify-content: center;
}
.tool-btn {
  padding: .08rem .24rem;
  box-sizing: border-box;
  background: #000;
  color: #FFFFFF;
  border-radius: .1rem;
  font-size: .24rem;
  margin-right: .28rem;
  cursor: pointer;
}

.lds-spinner {
  color: official;
  display: inline-block;
  position: relative;
  width: .8rem;
  height: .8rem;
}
.lds-spinner div {
  transform-origin: .4rem .4rem;
  animation: lds-spinner 1.2s linear infinite;
}
.lds-spinner div:after {
  content: " ";
  display: block;
  position: absolute;
  top: .03rem;
  left: .37rem;
  width: .06rem;
  height: .18rem;
  border-radius: 20%;
  background: #fff;
}
.lds-spinner div:nth-child(1) {
  transform: rotate(0deg);
  animation-delay: -1.1s;
}
.lds-spinner div:nth-child(2) {
  transform: rotate(30deg);
  animation-delay: -1s;
}
.lds-spinner div:nth-child(3) {
  transform: rotate(60deg);
  animation-delay: -0.9s;
}
.lds-spinner div:nth-child(4) {
  transform: rotate(90deg);
  animation-delay: -0.8s;
}
.lds-spinner div:nth-child(5) {
  transform: rotate(120deg);
  animation-delay: -0.7s;
}
.lds-spinner div:nth-child(6) {
  transform: rotate(150deg);
  animation-delay: -0.6s;
}
.lds-spinner div:nth-child(7) {
  transform: rotate(180deg);
  animation-delay: -0.5s;
}
.lds-spinner div:nth-child(8) {
  transform: rotate(210deg);
  animation-delay: -0.4s;
}
.lds-spinner div:nth-child(9) {
  transform: rotate(240deg);
  animation-delay: -0.3s;
}
.lds-spinner div:nth-child(10) {
  transform: rotate(270deg);
  animation-delay: -0.2s;
}
.lds-spinner div:nth-child(11) {
  transform: rotate(300deg);
  animation-delay: -0.1s;
}
.lds-spinner div:nth-child(12) {
  transform: rotate(330deg);
  animation-delay: 0s;
}
@keyframes lds-spinner {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

</style>
